import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const Wrapper = styled(motion.div)`
  padding: 15px 30px;
  padding-top: 30px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
`;

export const Header = styled(motion.div)`
  text-align: center;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
  margin-bottom: 30px;
`;

export const Actions = styled(motion.div)`
  display: flex;
  justify-content: space-between;
  gap: 28px;
  margin-top: 20px;

  button {
    border-radius: var(--pcm-rounded-lg);
    border: 1px solid var(--pcm-button-border-color);
    background-color: var(--pcm-body-background) !important;
    color: var(--pcm-body-background);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--pcm-body-color-secondary);

    &:hover {
      background-color: #fff;
    }
  }
`;

export const Description = styled.div`
  margin-top: 28px;
  padding: 0 16px;
  color: var(--pcm-body-color-secondary);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
